import React from 'react'
import { MoonLoader } from "react-spinners";

const Spinner = () => {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
        <MoonLoader size={22} speedMultiplier={0.9} />
        </div>
  )
}

export default Spinner
